import FileInput from './FileInput'
import FileInputField from './FileInputField'

export { FileInputField }
export default FileInput
